export const ClimateRegion = [
  {
    label: 'Region #1 - Red',
    value: 0.1,
  },
  {
    label: 'Region #2 - Orange',
    value: 0.05,
  },
  {
    label: 'Region #3 - Yellow',
    value: 0.0,
  },
  {
    label: 'Region #4 - Green',
    value: -0.05,
  },
  {
    label: 'Region #5 - Blue',
    value: -0.1,
  },
];

export const InsulationGrade = [
  {
    label: 'Extremely Well Insulated',
    value: 0.1,
  },
  {
    label: 'More than Average Insulation',
    value: 0.05,
  },
  {
    label: 'US Standard Insulation Grade',
    value: 0.0,
  },
  {
    label: 'Less than US Standard Insulation',
    value: -0.05,
  },
  {
    label: 'Poorly Insulated',
    value: -0.1,
  },
];

export const SunExposure = [
  {
    label: 'Strong Exposure',
    value: 0.08,
  },
  {
    label: 'Average Exposure',
    value: 0.0,
  },
  {
    label: 'Shaded or Interior',
    value: -0.08,
  },
];

export const AmountOfWindows = [
  {
    label: 'Average Amount',
    value: 0.0,
  },
  {
    label: 'More Windows than Average',
    value: 0.1,
  },
];

export const AirTightness = [
  {
    label: 'Double pane, Well sealed',
    value: -0.08,
  },
  {
    label: 'Average Design',
    value: 0.0,
  },
  {
    label: 'Single pane, Not perfectly sealed',
    value: 0.08,
  },
];

export const Occupants = [
  {
    label: '2 or less',
    value: 0,
  },
  {
    label: '3',
    value: 600,
  },
  {
    label: '4',
    value: 1200,
  },
  {
    label: '5',
    value: 1800,
  },
  {
    label: '6',
    value: 2400,
  },
];

export const ExtraDeviceWattage = [
  {
    label: '2',
    value: 0,
  },
  {
    label: '3',
    value: 600,
  },
  {
    label: '4',
    value: 1200,
  },
  {
    label: '5',
    value: 1800,
  },
  {
    label: '6',
    value: 2400,
  },
];
